import * as moment from 'moment';

export class DateUtils {

  static diffInMinutes(startDate: Date, endDate: Date): number {
    const start = moment(startDate);
    const end = moment(endDate);
    const diff = end.diff(start);
    return moment.duration(diff).asMinutes();
  }

  static minusYears(date: Date, years: number) {
    const result = new Date(date);
    result.setFullYear(result.getFullYear() - years);
    return result;
  }
  
  static truncate(date: Date) {
    if(!date) return null;
    return date.toISOString().split("T");
  }

  static formatDate(date: Date) {
    const monthNames = [
      "janeiro", "fevereiro", "março",
      "abril", "maio", "junho", "julho",
      "agosto", "setembro", "outubro",
      "novembro", "dezembro"
    ];

    const day = date.getDate();
    const monthIndex = date.getMonth();
    const year = date.getFullYear();

    return day + ' de ' + monthNames[monthIndex] + ' de ' + year;
  }

  static formatGetDateYear(date: Date) {
    return date.getFullYear();
  }

}